import React, { useState } from 'react';
import MobileLogo from './MobileLogo';
import MobileHeaderOpener from './MobileHeaderOpener';
import MobileNavigation from './MobileNavigation';

const MobileHeader = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(prev => !prev);
    };
    const closeMenu = () => {
        setIsMenuOpen(prev => !prev);
    };
    return (
        <header id="qodef-page-mobile-header" role="banner">
            <div id="qodef-page-mobile-header-inner">
                <MobileLogo />
                <MobileHeaderOpener toggleMenu={toggleMenu} isMenuOpen={isMenuOpen} />
            </div>
            {isMenuOpen && <MobileNavigation closeMenu={closeMenu} />}
        </header>
    );
};

export default MobileHeader;